import { FC } from 'react'
import Card from 'components/cards/base/Card'
import Landmark from 'components/icons/Landmark'
import Calculation from 'components/icons/Calculation'

type DesigendForKeySectorsType = {}
const benefits = [
  {
    description:
      'Embed our tools into onboarding flows. Reduce CPA, improve conversion, and introduce a valuable recurring product.',
    icon: <Landmark />,
    title: 'Fintech & Challenger Banks',
  },
  {
    description:
      'Offer director and registered office services without managing physical mail. We handle the post, so you don’t have to.',
    icon: <Calculation />,
    title: 'Accountants & Registration Agents',
  },
]
const DesigendForKeySectors: FC<DesigendForKeySectorsType> = ({}) => {
  return (
    <div className='d-flex flex-column align-items-center'>
      <h1 className='fs-fluid-36-80 lh-105 fw-semibold text-center'>
        Designed for <span className='color-pink2'>Key Sectors</span>
      </h1>
      <div className='row row-cols-1  flex-md-wrap  row-cols-md-2 g-3 g-md-5 align-items-stretch mt-6 mt-lg-11'>
        {benefits.map(({ description, icon, title }) => (
          <div>
            <Card padding='xl' shadow className='bg-white gap-5'>
              <div className='d-flex align-items-center gap-3 mb-2'>
                {icon}
                <h4 className='fs-fluid-24-32 color-pink2 fw-semibold lh-132 mb-0'>
                  {title}
                </h4>
              </div>
              <h3 className='fs-fluid-24-36 lh-140'>{description}</h3>
            </Card>
          </div>
        ))}
      </div>
    </div>
  )
}

export default DesigendForKeySectors
